









import { Component, Vue, Prop } from "vue-property-decorator";
import request from "@/api/index";
import { INewsItem, IShareInfo } from "@/api/types";
@Component
export default class Header extends Vue {
  @Prop()
  private newsId!: string;
  @Prop()
  private appId!: string;
  private shareInfo: IShareInfo | {} = {};
  private isShow: boolean = true;
  public request: request = new request();
  mounted() {
    this.request.getShareInfo().then(result => {
      this.shareInfo = result.data;
      if (ZWY_CLOUD.isOpenInApp()) {
        this.isShow = false;
      } else {
        this.isShow = true;
        const app = document.getElementsByClassName(
          "news-release"
        )[0] as HTMLDivElement;
        app.style.paddingTop = "16vw";
      }
    });
  }

  beforeDestroy() {
    this.close();
  }
  private close() {
    const app = document.getElementsByClassName(
      "news-release"
    )[0] as HTMLDivElement;
    app.style.paddingTop = "0";
    this.isShow = false;
  }

  private openApp() {
    const shareInfo = this.shareInfo as IShareInfo;
    if (!shareInfo.schemeUrl) {
      return (location.href = shareInfo.downloadUrl);
    }
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      const Params = {
        id: this.newsId,
        sourceId: this.newsId,
        sourceType: "1",
        url: location.href,
        shareUrl: location.href
      };
      location.href = `${shareInfo.schemeUrl}/info/install/${this.appId}.html?id=${this.newsId}&&&sourceId=${this.newsId}&&&sourceType=1&&&url=${location.href}&&&shareUrl=`;
    } else if (/(Android)/i.test(navigator.userAgent)) {
      const Params = {
        id: this.newsId,
        sourceId: this.newsId,
        sourceType: "1",
        url: location.href,
        shareUrl: location.href
      };
      location.href =
        shareInfo.schemeUrl.replace("http://", "").replace("com/", "com") +
        "://" +
        `?params=${JSON.stringify(Params)}`;
      setTimeout(() => {
        location.href = shareInfo.downloadUrl;
      }, 3000);
    } else {
      location.href = shareInfo.downloadUrl;
    }
  }
}
